export default __webpack_public_path__ + "static/media/hm-bold.fc4f50ec.woff2";